import {
    balanceOfFundsCosts,
    balanceOfFundsFunds
} from "../../../../app/components/client/application-stages/_common/funding/BalanceOfFunds";
import {BoolLike} from "../../../../models";
import {toEuroString} from "../../string-functions";
import dayjs from "dayjs";

const names = [
    {
        "name": "address",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "ber",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "ber-date",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "ber-discussed-no",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "ber-discussed-yes",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "ber-emmissions",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "ber-exempt-comfimed-no",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "ber-exempt-comfimed-yes",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "ber-exemption-uploaded-no",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "ber-exemption-uploaded-yes",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "ber-expiry",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "ber-kwh",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "ber-rating",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "ber-reference",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "ber-uploaded-no",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "ber-uploaded-yes",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "calculator",
        "type": "CHECK",
        "page": 1
    },
    {
        "name": "dra-name-1",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "dra-name-2",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "dra-name-3",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "dra-value-1",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "dra-value-2",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "dra-value-3",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "link",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "rate",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "solicitor",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "term",
        "type": "TEXT",
        "page": 1
    },
    {
        "name": "application-access-code",
        "type": "TEXT",
        "page": 2
    },
    {
        "name": "gift",
        "type": "TEXT",
        "page": 2
    },
    {
        "name": "gifter-relationship",
        "type": "TEXT",
        "page": 2
    },
    {
        "name": "giftor-name",
        "type": "TEXT",
        "page": 2
    },
    {
        "name": "htb",
        "type": "TEXT",
        "page": 2
    },
    {
        "name": "htb-application-code",
        "type": "TEXT",
        "page": 2
    },
    {
        "name": "htb-developer",
        "type": "TEXT",
        "page": 2
    },
    {
        "name": "inheritance-source",
        "type": "TEXT",
        "page": 2
    },
    {
        "name": "legal-fees",
        "type": "TEXT",
        "page": 2
    },
    {
        "name": "loan",
        "type": "TEXT",
        "page": 2
    },
    {
        "name": "price",
        "type": "TEXT",
        "page": 2
    },
    {
        "name": "savings",
        "type": "TEXT",
        "page": 2
    },
    {
        "name": "stamp-duty",
        "type": "TEXT",
        "page": 2
    },
    {
        "name": "total-outlay",
        "type": "TEXT",
        "page": 2
    }
]
export default function (mortgage, config) {
    let map = {}
    let fill = {}
    let ask = []
    const errors = []

    const section1 = () => {
        ask.push({
            name: 'cboi-exception',
            label: 'CBOI Exception',
            type: 'CHECK',
            group: 'Loan Details'
        })
        if (config.hasOwnProperty('cboi-exception') && config['cboi-exception'] === true) {
            map['cboi-exception-no'] = 'XXX'
        } else {
            map['cboi-exception-yes'] = 'XXX'
        }

        map['rate'] = (mortgage.activeSubmission?.finalRate || mortgage.activeSubmission?.provisionalRate) + '% ' + (mortgage.activeSubmission?.finalProduct || mortgage.activeSubmission?.provisionalProduct || '')
        map['term'] = (mortgage.activeSubmission?.finalTerm || mortgage.activeSubmission?.provisionalTerm) + ' Years'
        map['solicitor'] = mortgage.solicitor.firmName + ', ' + mortgage.solicitor.firmAddress
    }
    const lendingCriteria = () => {
        ask.push({
            name: 'calculator',
            label: 'BOI Calculator Included',
            type: 'CHECK',
            group: 'Loan Details'
        })
        map['calculator'] = config.hasOwnProperty('calculator') && config.calculator ? 'YES' : 'NO'

        // const newTestesFigures = JSON.parse(mortgage.activeSubmission?.verifiedFiguresTest?.test.figures)
        // let accommodationNew = (newTestesFigures.applicant1?.pra?.boarding || 0) + (newTestesFigures.applicant1?.pra?.rent || 0) + (newTestesFigures.applicant1?.pra?.mortgage || 0)
        // if (newTestesFigures.twoApplicants) {
        // 	accommodationNew += (newTestesFigures.applicant2?.pra?.boarding || 0) + (newTestesFigures.applicant2?.pra?.rent || 0) + (newTestesFigures.applicant2?.pra?.mortgage || 0)
        // }

        ask.push({
            name: 'dra-name-1',
            label: 'DRA1 Desc',
            type: 'TEXT',
            group: 'DRA'
        })
        ask.push({
            name: 'dra-value-1',
            label: 'DRA1 Value',
            type: 'TEXT',
            group: 'DRA'
        })
        ask.push({
            name: 'dra-name-2',
            label: 'DRA2 Desc',
            type: 'TEXT',
            group: 'DRA'
        })
        ask.push({
            name: 'dra-value-2',
            label: 'DRA2 Value',
            type: 'TEXT',
            group: 'DRA'
        })
        ask.push({
            name: 'dra-name-3',
            label: 'DRA3 Desc',
            type: 'TEXT',
            group: 'DRA'
        })
        ask.push({
            name: 'dra-value-3',
            label: 'DRA3 Value',
            type: 'TEXT',
            group: 'DRA'
        })
        ask.push({
            name: 'dra-name-4',
            label: 'DRA4 Desc',
            type: 'TEXT',
            group: 'DRA'
        })
        ask.push({
            name: 'dra-value-4',
            label: 'DRA4 Value',
            type: 'TEXT',
            group: 'DRA'
        })
        if (config.hasOwnProperty('dra-name-1') && !!config['dra-name-1'] && config.hasOwnProperty('dra-value-1') && !!config['dra-value-1']) {
            map['dra-name-1'] = config['dra-name-1']
            map['dra-value-1'] = config['dra-value-1']
        }
        if (config.hasOwnProperty('dra-name-2') && !!config['dra-name-2'] && config.hasOwnProperty('dra-value-2') && !!config['dra-value-2']) {
            map['dra-name-2'] = config['dra-name-2']
            map['dra-value-2'] = config['dra-value-2']
        }
        if (config.hasOwnProperty('dra-name-3') && !!config['dra-name-3'] && config.hasOwnProperty('dra-value-3') && !!config['dra-value-3']) {
            map['dra-name-3'] = config['dra-name-3']
            map['dra-value-3'] = config['dra-value-3']
        }
        if (config.hasOwnProperty('dra-name-4') && !!config['dra-name-4'] && config.hasOwnProperty('dra-value-4') && !!config['dra-value-4']) {
            map['dra-name-4'] = config['dra-name-4']
            map['dra-value-4'] = config['dra-value-4']
        }
        if (!map['dra-name-1'] && !map['dra-name-2'] && !map['dra-name-3'] && !map['dra-name-4']) {
            map['dra-name-1'] = 'No Changes'
        }
        // PRA
        // const accommodation = mortgage.activeSubmission?.provisionalXlsInput.figures.accommodationCostsTotal
        // const otherPRA = mortgage.activeSubmission?.provisionalXlsInput.figures.otherPRATotal
        // const clearingLoans = mortgage.activeSubmission?.provisionalXlsInput.figures.clearingLoansTotal
        // const savings = mortgage.activeSubmission?.provisionalXlsInput.figures.savingsTotal
        // let all = []
        // if (accommodation > 0) {
        // 	all.push({Accommodation: accommodation})
        // }
        // if (otherPRA > 0) {
        // 	all.push({OtherPRA: otherPRA})
        // }
        // if (clearingLoans > 0) {
        // 	all.push({ClearingLoans: clearingLoans})
        // }
        // if (savings > 0) {
        // 	all.push({Savings: savings})
        // }
        // all.forEach((item, i) => {
        // 	let key = Object.keys(item)[0]
        // 	let value = Object.values(item)[0]
        // 	map[`dra-name-${i + 1}`] = key.toString()
        // 	map[`dra-value-${i + 1}`] = value.toString()
        // })
    }
    const property = () => {
        map['address'] = mortgage.property.address || ''
        ask.push({
            name: 'link',
            label: 'Link To Property',
            type: 'TEXT',
            group: 'Property'
        });
        if (config.hasOwnProperty('link') && !!config['link']) {
            map['link'] = config['link'];
        }

        // BER DISCUSSED
        if ([true, false].includes(mortgage.property.berDiscussed)) {
            if (mortgage.property.berDiscussed) {

                map['ber-discussed-no'] = "XXX"
            } else {

                map['ber-discussed-yes'] = "XXX"
            }
        }
        else{
            ask.push({
                name: 'ber-discussed',
                label: 'BER Discussed',
                type: 'CHECK',
                group: 'Property'
            })
            if (config.hasOwnProperty('ber-discussed') && [
                true,
                false
            ].includes(config['ber-discussed'])) {
                if (config['ber-discussed']) {

                    map['ber-discussed-no'] = "XXX"
                } else {

                    map['ber-discussed-yes'] = "XXX"
                }
            } else {

                map['ber-discussed-yes'] = "XXX"
            }
        }

        // BER UPLOADED
        if (mortgage.uploadSections.find(it => it.name === 'ber-certificate' && it.isActive && it.stage === 'PREAPPROVAL')) {
            map['ber-uploaded-no'] = "XXX"
        }
        else{
            ask.push({
                name: 'ber-uploaded',
                label: 'BER Uploaded',
                type: 'CHECK',
                group: 'Property'
            })
            if (config.hasOwnProperty('ber-uploaded') && [
                true,
                false
            ].includes(config['ber-uploaded'])) {
                if (config['ber-uploaded']) {
                    map['ber-uploaded-no'] = "XXX"
                } else {
                    map['ber-uploaded-yes'] = "XXX"
                }
            } else {
                map['ber-uploaded-no'] = "XXX"
            }
        }

        // BER REFERENCE
        if (mortgage.property.berReference != null){
            map['ber-reference'] = mortgage.property.berReference
        }
        else{
            ask.push({
                name: 'ber-reference',
                label: 'BER Reference',
                type: 'TEXT',
                group: 'Property'
            })
            if (config.hasOwnProperty('ber-reference') && !!config['ber-reference']) {
                map['ber-reference'] = config['ber-reference'];
            }
        }

        // BER RATING
        map['ber-rating'] = mortgage.property.berScore || ''

        // BER EXPIRY DATE
        if (mortgage.property.berExpiryDate){
            map['ber-expiry'] = dayjs(mortgage.property.berExpiryDate, "YYYY-MM-DD").format('D MMM YYYY')
        }
        else{
            ask.push({
                name: 'ber-expiry',
                label: 'BER Expiry Date',
                type: 'TEXT',
                group: 'Property'
            })
            if (config.hasOwnProperty('ber-expiry') && !!config['ber-expiry']) {
                map['ber-expiry'] = config['ber-expiry'];
            }
        }

        // BER EMISSIONS
        if (mortgage.property.berEmissions){
            map['ber-emmissions'] = mortgage.property.berEmissions
        }
        else{
            ask.push({
                name: 'ber-emmissions',
                label: 'BER Emmissions',
                type: 'TEXT',
                group: 'Property'
            })
            if (config.hasOwnProperty('ber-emmissions') && !!config['ber-emmissions']) {
                map['ber-emmissions'] = config['ber-emmissions'];
            }
        }

        // BER KWH
        if (mortgage.property.berKwhPerM2){
            map['ber-kwh'] = mortgage.property.berKwhPerM2
        }
        else{
            ask.push({
                name: 'ber-kwh',
                label: 'BER KWH per m2',
                type: 'TEXT',
                group: 'Property'
            })
            if (config.hasOwnProperty('ber-kwh') && !!config['ber-kwh']) {
                map['ber-kwh'] = config['ber-kwh'];
            }

        }

        // BER DATE OF ISSUE
        if (mortgage.property.berDateOfIssue){
            map['ber-date'] = dayjs(mortgage.property.berDateOfIssue, "YYYY-MM-DD").format('D MMM YYYY')
        }
        else{
            ask.push({
                name: 'ber-date',
                label: 'BER Date of Issue',
                type: 'TEXT',
                group: 'Property'
            })
            if (config.hasOwnProperty('ber-date') && !!config['ber-date']) {
                map['ber-date'] = config['ber-date'];
            }
        }

        if (mortgage.uploadSections.find(it => it.name === 'ber-exemption' && it.isActive && it.stage === 'PREAPPROVAL')) {
            map['ber-exemption-uploaded-no'] = "XXX"
        }
        else{
            ask.push({
                name: 'ber-exemption-uploaded',
                label: 'BER Exemption Uploaded',
                type: 'CHECK',
                group: 'Property'
            })
            if (config.hasOwnProperty('ber-exemption-uploaded') && [
                true,
                false
            ].includes(config['ber-exemption-uploaded'])) {
                if (config['ber-exemption-uploaded']) {
                    map['ber-exemption-uploaded-no'] = "XXX"
                } else {
                    map['ber-exemption-uploaded-yes'] = "XXX"
                }
            }
        }

        if ([true, false].includes(mortgage.property.berExemptionConfirmed)) {
            if (config['ber-exempt-comfimed']) {
                map['ber-exempt-comfimed-no'] = "XXX"
            } else {
                map['ber-exempt-comfimed-yes'] = "XXX"
            }
        }
        else{
            ask.push({
                name: 'ber-exempt-comfimed',
                label: 'BER Exemption Confirmed',
                type: 'CHECK',
                group: 'Property'
            })
            if (config.hasOwnProperty('ber-exempt-comfimed') && [
                true,
                false
            ].includes(config['ber-exempt-comfimed'])) {
                if (config['ber-exempt-comfimed']) {
                    map['ber-exempt-comfimed-no'] = "XXX"
                } else {
                    map['ber-exempt-comfimed-yes'] = "XXX"
                }
            }
        }



    }
    const outlay = () => {
        map['price'] = (mortgage.property.propertyPrice || mortgage.property.propertyValue).toString()
        const {
            stampDuty,
            legalFees
        } = balanceOfFundsCosts(mortgage, {
            price: map['price'].toLocaleString('en-US')
        })

        map['stamp-duty'] = (stampDuty || '').toLocaleString('en-US')
        map['legal-fees'] = (legalFees || '').toLocaleString('en-US')
        map['total-outlay'] = ((parseFloat(stampDuty || 0)) + (parseFloat(legalFees || 0)) + parseFloat(map['price']) || '').toLocaleString('en-US')
    }
    const funding = () => {
        const funding = balanceOfFundsFunds(mortgage)

        //map['loan'] = ( mortgage.activeSubmission?.finalLoan || mortgage.activeSubmission?.provisionalLoan || mortgage.requirement.loanRequired).toLocaleString('en-US')
        map['loan'] = toEuroString(funding.loan)

        map['savings'] = toEuroString(funding.requiredSavings)
        ask.push({
            name: 'inheritance',
            label: 'Inheritance + Gift Amount',
            type: 'TEXT',
            group: 'Funding'
        })
        if (config.hasOwnProperty('inheritance') && !!config['inheritance']) {
            map['gift'] = config['inheritance']?.toLocaleString('en-US');
        } else if (mortgage.requirement.receivingGifts) {
            //map['gift'] = (mortgage.requirement.depositGifts || 0).toLocaleString('en-US')
            map['gift'] = toEuroString(funding.gifts)
        }
        if (mortgage.requirement.helpToBuyScheme !== BoolLike.FALSE) {
            map['htb'] = (mortgage.requirement.helpToBuySchemeAmount || 0).toLocaleString('en-US')
            ask.push({
                    name: 'htb-access-code',
                    label: 'HTB Access Code',
                    type: 'TEXT',
                    group: 'HTB'
                },
                {
                    name: 'htb-application-code',
                    label: 'HTB Application Code',
                    type: 'TEXT',
                    group: 'HTB'
                },
                {
                    name: 'htb-developer',
                    label: 'HTB Developer',
                    type: 'TEXT',
                    group: 'HTB'
                })
            const things = []
            if (mortgage.requirement.helpToBuySchemeDeveloperName) {
                things.push({'htb-developer': 'Developer: ' + mortgage.requirement.helpToBuySchemeDeveloperName})
            } else if (config.hasOwnProperty('htb-developer') && !!config['htb-developer']) {
                things.push({'htb-developer': 'Developer: ' + config['htb-developer']})
            }
            if (mortgage.requirement.helpToBuySchemeApplicationCode) {
                things.push({'htb-application-code': 'Application Code: ' + mortgage.requirement.helpToBuySchemeApplicationCode})
            } else if (config.hasOwnProperty('htb-application-code') && !!config['htb-application-code']) {
                things.push({'htb-application-code': 'Application Code: ' + config['htb-application-code']})
            }
            if (mortgage.requirement.helpToBuySchemeAccessCode) {
                things.push({'htb-access-code': 'Access Code: ' + mortgage.requirement.helpToBuySchemeAccessCode})
            } else if (config.hasOwnProperty('htb-access-code') && !!config['htb-access-code']) {
                things.push({'htb-access-code': 'Access Code: ' + config['htb-access-code']})
            }

            things.forEach((thing, i) => {
                const key = Object.keys(thing)[0]
                const value = Object.values(thing)[0]
                map[key] = value.toLocaleString('en-US')
            })

        }

        const customFunding = []
        if (funding.bookingDepositPaid) {
            customFunding.push({name: 'Booking Deposit Paid', value: funding.bookingDepositPaid.toLocaleString('en-US')})
        }
        if (funding.contractDepositPaid) {
            customFunding.push({name: 'Contract Deposit Paid', value: funding.contractDepositPaid.toLocaleString('en-US')})
        }
        if (funding.firstHome){
            customFunding.push({name: 'First Home Scheme', value: funding.firstHome.toLocaleString('en-US')})
        }
        if (funding.sellingProperties){
            customFunding.push({name: 'Sale of Property', value: funding.sellingProperties.toLocaleString('en-US')})
        }
        if (customFunding.length > 3) {
            errors.push('More than two custom funding sources present, cannot fit all to form')
        }
        customFunding.forEach((item, i) => {
            map[`extra-funding-name-${i+1}`] = item.name
            map[`funding-extra-amt-${i+1}`] = item.value
        })



        const total = funding.totalFunds //(parseFloat(map['loan'].replace(/,/g, '')) || 0) + (parseFloat(map['savings'].toString().replace(/,/g, '')) || 0) + (parseFloat(map['gift']?.toString().replace(/,/g, '') || '0')) + (parseFloat(map['htb']?.toString().replace(/,/g, '') || '0'))
        map['funding-total'] = total.toLocaleString('en-US')


        const confirmedSavingsSection = mortgage.uploadSections.find(it => it.name === 'proof-of-deposit' && it.isActive)
        console.log({confirmedSavingsSection})
        const confirmedSavings = confirmedSavingsSection ? confirmedSavingsSection.activeUploads.filter(it=>it.isVerifiable).map(
            (upload,i) => ({
                name: upload.values.bankName,
                amount: upload.values?.closingBalance,
                date: upload.values?.documentDate?.format('D MMM YYYY')
            })
        ) : 0
        console.log({confirmedSavings})
        if (confirmedSavings && confirmedSavings.some(it => !it.name || !it.amount || !it.date)) {
            errors.push('Some confirmed savings uploads are missing required fields (bank name, amount, date)')
        }
        confirmedSavings.forEach((item, i) => {
            map[`desc-${i + 1}`] = item.name
            map[`date-${i + 1}`] = item.date
            map[`amt-${i + 1}`] = toEuroString(item.amount)
        })
        const sum = confirmedSavings.reduce((acc, cur) => acc + parseFloat(cur.amount || 0), 0)
        if (confirmedSavings.length <=7){
            map[`amt-${confirmedSavings.length + 1}`] =  "TOTAL: " + toEuroString(sum)
            map[`amt-${confirmedSavings.length + 2}`] = "Surplus: " + toEuroString( sum - funding.requiredSavings )
        }
        else{
            map['total-funds'] = "TOTAL: " + toEuroString(sum)
            map['surplus'] = "Surplus: " + toEuroString(sum - funding.requiredSavings  )
        }



    }
    const gifts = () => {

        if (mortgage.requirement.receivingGifts && mortgage.requirement.gifters) {
            const gifters = JSON.parse(mortgage.requirement.gifters)
            gifters.forEach((person, i) => {
                let ind = i + 1
                map[`giftor-name-${ind}`] = person.fullName;
                map[`gifter-relationship-${ind}`] = person.relationship;
            })
        } else {
            ask.push({
                name: 'giftor-name',
                label: 'Giftor Name',
                type: 'TEXT',
                group: 'Gifts'
            })
            ask.push({
                name: 'gifter-relationship',
                label: 'Relationship to Applicant',
                type: 'TEXT',
                group: 'Gifts'
            })
            if (config.hasOwnProperty('giftor-name') && !!config['giftor-name']) {
                map['giftor-name-1'] = config['giftor-name'];
                if (config.hasOwnProperty('gifter-relationship') && !!config['gifter-relationship']) {
                    map['gifter-relationship-1'] = config['gifter-relationship'];
                }
            }
        }

    }

    section1()
    lendingCriteria()
    property()
    outlay()
    funding()
    gifts()

    return {
        sections: [
            {
                fill,
                ask,
                map,
                errors
            }
        ]
    }
}
